import { defineComponent as ye, toRef as d, ref as R, computed as s, watch as z, nextTick as Re, onBeforeUnmount as Se, provide as O, onMounted as xe, h as a } from "vue";
import { createKey as y } from "./ghl-ui.es384.js";
import Fe from "./ghl-ui.es1147.js";
import w from "./ghl-ui.es1568.js";
import _ from "./ghl-ui.es1569.js";
import { internalSelectionMenuInjectionKey as Ce, internalSelectionMenuBodyInjectionKey as Te } from "./ghl-ui.es1499.js";
import Pe from "./ghl-ui.es1570.js";
import B from "./ghl-ui.es855.js";
import Me from "./ghl-ui.es854.js";
import { useRtl as Ne } from "./ghl-ui.es851.js";
import ke from "./ghl-ui.es1160.js";
import { createIndexGetter as ze } from "./ghl-ui.es1141.js";
import { depx as Oe, getMargin as F } from "./ghl-ui.es856.js";
import { useThemeClass as we } from "./ghl-ui.es857.js";
import { useOnResize as _e } from "./ghl-ui.es1149.js";
import { resolveWrappedSlot as L, resolveSlot as Be } from "./ghl-ui.es860.js";
import Le from "./ghl-ui.es906.js";
import Ie from "./ghl-ui.es994.js";
import Ke from "./ghl-ui.es215.js";
import { happensIn as I } from "./ghl-ui.es944.js";
import De from "./ghl-ui.es1007.js";
const rn = ye({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, B.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    scrollable: {
      type: Boolean,
      default: !0
    },
    treeMate: {
      type: Object,
      required: !0
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: !0
    },
    // show is used to toggle pending state initialization
    show: {
      type: Boolean,
      default: !0
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: {
      type: Boolean,
      default: !0
    },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    inlineThemeDisabled: Boolean,
    // deprecated
    onToggle: Function
  }),
  setup(t) {
    const {
      mergedClsPrefixRef: c,
      mergedRtlRef: l
    } = Me(t), v = Ne("InternalSelectMenu", l, c), m = B("InternalSelectMenu", "-internal-select-menu", Pe, ke, t, d(t, "clsPrefix")), r = R(null), o = R(null), g = R(null), S = s(() => t.treeMate.getFlattenedNodes()), K = s(() => ze(S.value)), u = R(null);
    function D() {
      const {
        treeMate: e
      } = t;
      let n = null;
      const {
        value: i
      } = t;
      i === null ? n = e.getFirstAvailableNode() : (t.multiple ? n = e.getNode((i || [])[(i || []).length - 1]) : n = e.getNode(i), (!n || n.disabled) && (n = e.getFirstAvailableNode())), p(n || null);
    }
    function C() {
      const {
        value: e
      } = u;
      e && !t.treeMate.getNode(e.key) && (u.value = null);
    }
    let f;
    z(() => t.show, (e) => {
      e ? f = z(() => t.treeMate, () => {
        t.resetMenuOnOptionsChange ? (t.autoPending ? D() : C(), Re(M)) : C();
      }, {
        immediate: !0
      }) : f == null || f();
    }, {
      immediate: !0
    }), Se(() => {
      f == null || f();
    });
    const T = s(() => Oe(m.value.self[y("optionHeight", t.size)])), E = s(() => F(m.value.self[y("padding", t.size)])), $ = s(() => t.multiple && Array.isArray(t.value) ? new Set(t.value) : /* @__PURE__ */ new Set()), A = s(() => {
      const e = S.value;
      return e && e.length === 0;
    });
    function V(e) {
      const {
        onToggle: n
      } = t;
      n && n(e);
    }
    function P(e) {
      const {
        onScroll: n
      } = t;
      n && n(e);
    }
    function H(e) {
      var n;
      (n = g.value) === null || n === void 0 || n.sync(), P(e);
    }
    function j() {
      var e;
      (e = g.value) === null || e === void 0 || e.sync();
    }
    function G() {
      const {
        value: e
      } = u;
      return e || null;
    }
    function U(e, n) {
      n.disabled || p(n, !1);
    }
    function W(e, n) {
      n.disabled || V(n);
    }
    function q(e) {
      var n;
      I(e, "action") || (n = t.onKeyup) === null || n === void 0 || n.call(t, e);
    }
    function J(e) {
      var n;
      I(e, "action") || (n = t.onKeydown) === null || n === void 0 || n.call(t, e);
    }
    function Q(e) {
      var n;
      (n = t.onMousedown) === null || n === void 0 || n.call(t, e), !t.focusable && e.preventDefault();
    }
    function X() {
      const {
        value: e
      } = u;
      e && p(e.getNext({
        loop: !0
      }), !0);
    }
    function Y() {
      const {
        value: e
      } = u;
      e && p(e.getPrev({
        loop: !0
      }), !0);
    }
    function p(e, n = !1) {
      u.value = e, n && M();
    }
    function M() {
      var e, n;
      const i = u.value;
      if (!i)
        return;
      const b = K.value(i.key);
      b !== null && (t.virtualScroll ? (e = o.value) === null || e === void 0 || e.scrollTo({
        index: b
      }) : (n = g.value) === null || n === void 0 || n.scrollTo({
        index: b,
        elSize: T.value
      }));
    }
    function Z(e) {
      var n, i;
      !((n = r.value) === null || n === void 0) && n.contains(e.target) && ((i = t.onFocus) === null || i === void 0 || i.call(t, e));
    }
    function ee(e) {
      var n, i;
      !((n = r.value) === null || n === void 0) && n.contains(e.relatedTarget) || (i = t.onBlur) === null || i === void 0 || i.call(t, e);
    }
    O(Ce, {
      handleOptionMouseEnter: U,
      handleOptionClick: W,
      valueSetRef: $,
      pendingTmNodeRef: u,
      nodePropsRef: d(t, "nodeProps"),
      showCheckmarkRef: d(t, "showCheckmark"),
      multipleRef: d(t, "multiple"),
      valueRef: d(t, "value"),
      renderLabelRef: d(t, "renderLabel"),
      renderOptionRef: d(t, "renderOption"),
      labelFieldRef: d(t, "labelField"),
      valueFieldRef: d(t, "valueField")
    }), O(Te, r), xe(() => {
      const {
        value: e
      } = g;
      e && e.sync();
    });
    const N = s(() => {
      const {
        size: e
      } = t, {
        common: {
          cubicBezierEaseInOut: n
        },
        self: {
          height: i,
          borderRadius: b,
          color: te,
          groupHeaderTextColor: oe,
          actionDividerColor: ie,
          optionTextColorPressed: le,
          optionTextColor: ae,
          optionTextColorDisabled: re,
          optionTextColorActive: de,
          optionOpacityDisabled: ue,
          optionCheckColor: se,
          actionTextColor: ce,
          optionColorPending: fe,
          optionColorActive: ve,
          loadingColor: me,
          loadingSize: he,
          optionColorActivePending: ge,
          [y("optionFontSize", e)]: pe,
          [y("optionHeight", e)]: be,
          [y("optionPadding", e)]: x
        }
      } = m.value;
      return {
        "--n-height": i,
        "--n-action-divider-color": ie,
        "--n-action-text-color": ce,
        "--n-bezier": n,
        "--n-border-radius": b,
        "--n-color": te,
        "--n-option-font-size": pe,
        "--n-group-header-text-color": oe,
        "--n-option-check-color": se,
        "--n-option-color-pending": fe,
        "--n-option-color-active": ve,
        "--n-option-color-active-pending": ge,
        "--n-option-height": be,
        "--n-option-opacity-disabled": ue,
        "--n-option-text-color": ae,
        "--n-option-text-color-active": de,
        "--n-option-text-color-disabled": re,
        "--n-option-text-color-pressed": le,
        "--n-option-padding": x,
        "--n-option-padding-left": F(x, "left"),
        "--n-option-padding-right": F(x, "right"),
        "--n-loading-color": me,
        "--n-loading-size": he
      };
    }), {
      inlineThemeDisabled: k
    } = t, h = k ? we("internal-select-menu", s(() => t.size[0]), N, t) : void 0, ne = {
      selfRef: r,
      next: X,
      prev: Y,
      getPendingTmNode: G
    };
    return _e(r, t.onResize), Object.assign({
      mergedTheme: m,
      mergedClsPrefix: c,
      rtlEnabled: v,
      virtualListRef: o,
      scrollbarRef: g,
      itemSize: T,
      padding: E,
      flattenedNodes: S,
      empty: A,
      virtualListContainer() {
        const {
          value: e
        } = o;
        return e == null ? void 0 : e.listElRef;
      },
      virtualListContent() {
        const {
          value: e
        } = o;
        return e == null ? void 0 : e.itemsElRef;
      },
      doScroll: P,
      handleFocusin: Z,
      handleFocusout: ee,
      handleKeyUp: q,
      handleKeyDown: J,
      handleMouseDown: Q,
      handleVirtualListResize: j,
      handleVirtualListScroll: H,
      cssVars: k ? void 0 : N,
      themeClass: h == null ? void 0 : h.themeClass,
      onRender: h == null ? void 0 : h.onRender
    }, ne);
  },
  render() {
    const {
      $slots: t,
      virtualScroll: c,
      clsPrefix: l,
      mergedTheme: v,
      themeClass: m,
      onRender: r
    } = this;
    return r == null || r(), a("div", {
      ref: "selfRef",
      tabindex: this.focusable ? 0 : -1,
      class: [`${l}-base-select-menu`, this.rtlEnabled && `${l}-base-select-menu--rtl`, m, this.multiple && `${l}-base-select-menu--multiple`],
      style: this.cssVars,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onKeyup: this.handleKeyUp,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, L(t.header, (o) => o && a("div", {
      class: `${l}-base-select-menu__header`,
      "data-header": !0,
      key: "header"
    }, o)), this.loading ? a("div", {
      class: `${l}-base-select-menu__loading`
    }, a(Le, {
      clsPrefix: l,
      strokeWidth: 20
    })) : this.empty ? a("div", {
      class: `${l}-base-select-menu__empty`,
      "data-empty": !0
    }, Be(t.empty, () => [a(De, {
      theme: v.peers.Empty,
      themeOverrides: v.peerOverrides.Empty
    })])) : a(Ie, {
      ref: "scrollbarRef",
      theme: v.peers.Scrollbar,
      themeOverrides: v.peerOverrides.Scrollbar,
      scrollable: this.scrollable,
      container: c ? this.virtualListContainer : void 0,
      content: c ? this.virtualListContent : void 0,
      onScroll: c ? void 0 : this.doScroll
    }, {
      default: () => c ? a(Ke, {
        ref: "virtualListRef",
        class: `${l}-virtual-list`,
        items: this.flattenedNodes,
        itemSize: this.itemSize,
        showScrollbar: !1,
        paddingTop: this.padding.top,
        paddingBottom: this.padding.bottom,
        onResize: this.handleVirtualListResize,
        onScroll: this.handleVirtualListScroll,
        itemResizable: !0
      }, {
        default: ({
          item: o
        }) => o.isGroup ? a(_, {
          key: o.key,
          clsPrefix: l,
          tmNode: o
        }) : o.ignored ? null : a(w, {
          clsPrefix: l,
          key: o.key,
          tmNode: o
        })
      }) : a("div", {
        class: `${l}-base-select-menu-option-wrapper`,
        style: {
          paddingTop: this.padding.top,
          paddingBottom: this.padding.bottom
        }
      }, this.flattenedNodes.map((o) => o.isGroup ? a(_, {
        key: o.key,
        clsPrefix: l,
        tmNode: o
      }) : a(w, {
        clsPrefix: l,
        key: o.key,
        tmNode: o
      })))
    }), L(t.action, (o) => o && [a("div", {
      class: `${l}-base-select-menu__action`,
      "data-action": !0,
      key: "action"
    }, o), a(Fe, {
      onFocus: this.onTabOut,
      key: "focus-detector"
    })]));
  }
});
export {
  rn as default
};
